import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { jobPositionsAPI } from '../../lib/api';
import { GroupBlock, TRAINING_CATEGORY_LABELS } from './classificationGroups';

export const CargoClassificationDialog = ({ open, onClose }) => {
  const [data, setData] = useState(null);
  const [cargoId, setCargoId] = useState('');

  useEffect(() => {
    if (!open) return;
    setData(null);
    jobPositionsAPI.getClassification()
      .then((r) => { setData(r.data); setCargoId(r.data[0]?.id || ''); })
      .catch(() => { toast.error('Erro ao carregar descrições de cargo'); onClose(); });
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const cargo = data?.find((c) => c.id === cargoId);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto" data-testid="cargo-classification-dialog">
        <DialogHeader>
          <DialogTitle>Visão por Cargo</DialogTitle>
          <DialogDescription>
            Itens da descrição de cargo separados automaticamente. O cadastro do cargo não é alterado.
          </DialogDescription>
        </DialogHeader>
        {!data ? (
          <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-cyan-600" /></div>
        ) : data.length === 0 ? (
          <p className="py-8 text-center text-slate-500">Nenhuma descrição de cargo cadastrada</p>
        ) : (
          <div className="space-y-4">
            <Select value={cargoId} onValueChange={setCargoId}>
              <SelectTrigger className="w-full md:w-96" data-testid="cargo-classification-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {data.map((c) => (
                  <SelectItem key={c.id} value={c.id}>
                    {c.titulo}{c.codigo_cargo ? ` (cód. ${c.codigo_cargo})` : ''}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {cargo && (
              <div className="grid md:grid-cols-3 gap-4">
                <GroupBlock group="treinamento" items={cargo.treinamentos} testId="group-treinamentos"
                  renderMeta={(t) => TRAINING_CATEGORY_LABELS[t.categoria] || t.categoria} />
                <GroupBlock group="requisito" items={cargo.requisitos} testId="group-requisitos"
                  renderMeta={(r) => `${r.categoria}${r.obrigatorio ? '' : ' · desejável'}`} />
                <GroupBlock group="competencia" items={cargo.competencias} testId="group-competencias" />
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
